/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  Col,
  size,
  typography,
  colors,
  mediaQueries,
} from '@everlywell/leaves';
import styled from 'styled-components';
import Container from '../Container';

const NewsBackground = styled.div`
  width: 100%;
  background-color: ${colors.teal1};
`;

const NewsContainer = styled(Container)`
  padding-bottom: ${size.xl4}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: ${size.xl7}px;
  }
`;

const NewsCol = styled(Col)`
  display: flex;
  justify-content: center;

  &:last-child {
    ${mediaQueries.forDesktopUp} {
      margin-right: ${size.xl1}px;
    }
  }

  &:not(:last-child) {
    margin-bottom: ${size.xl1}px;

    ${mediaQueries.forTabletHorizontalUp} {
      margin-bottom: 0;
    }

    ${mediaQueries.forDesktopUp} {
      margin: 0 ${size.xl1}px;
    }
  }
`;

const QuoteContainer = styled.div`
  background-color: ${colors.white};
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: min(100%, 31.313rem);
  padding: ${size.xl2}px ${size.lg}px;
  box-shadow: 0 2px 30px -5px rgba(0, 0, 0, 0.1);
  margin: 0;

  .gatsby-image-wrapper {
    width: 100%;
    padding-bottom: 7%;
    max-height: 2.187rem;

    img {
      object-fit: contain;
      object-position: left;
    }
  }
`;

const QuotesSections = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: wrap;
  justify-content: center;
  padding-top: ${size.xl4}px;
`;

const QuoteText = styled.p`
  ${typography.bodyText}
  font-weight: ${typography.weight.book};
  font-size: 1.424rem;
  margin: ${size.lg}px 0;
  text-align: left;
`;

export {
  NewsBackground,
  NewsContainer,
  NewsCol,
  QuoteContainer,
  QuotesSections,
  QuoteText,
};
